import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// utils
import { Translations } from '../../../utils/';
// constant
import { FORM_REFS } from '../../../constants';
// restClient
import { eapiClient, aemHostClient } from '../../../restClient';
// children
import Dynamicform from '../../common/Dynamicform/dynamicForm';
//action Creator
import { hideActionButton } from '../../layouts/actions/actionCreator';
import {
  setGslAgent,
} from '../../CaseBody/actions/actionCreator';
import { updateCase } from '../actions/actionCreator';

const CreateNewGLSproduct = (props) => {
  const [btnDisabled, setBtnDisabled] = useState();
  const [formData, setFormData] = useState();
  const [formJson, setFormJson] = useState();

  const translations = (text) => {
    return Translations(text, props.lang.currentLang.lang, props.lang.translatedData)
  }

  useEffect(() => {
    let apiURL = "/aemData/formData/json_add-gls";
    if (props.mode === "edit") {
      apiURL = apiURL.replace("add-", "edit-");
    }
    (async () => {
      const { data } = await aemHostClient(apiURL);
      setFormJson(data)
    })();
    return () => {
      // Anything in here is fired on component unmount.
    }
  }, [])

  useEffect(() => {
    if (props.history.location.pathname.includes("/create-a-case/")) {
      props.hideCrumbs();
    }
    props.hideActionButton();
  }, []);

  const getFormData = (formData) => {
    setFormData(formData)
    // this.setState({ formData });
  }

  const electingCases = (obj, searchKey) => {
    for (var key in obj) {
      if (obj[key].entityName === searchKey) {
        return key
      }
    }
  }

  const checkToAddProduct = (productInfo, glsProducts) => {
    let _glsProducts = []
    for (let [key, value] of Object.entries(glsProducts)) {
      _glsProducts.push(value);
    }
    return _glsProducts.some(type => type.glsProductType.value === productInfo)
  }

  const submitFormData = (event, apiURL) => {
    let productInfo = formData.glsProductType.value
    let caseId = electingCases(props.cases, formData.glsAgent.name);
    let glsProducts = props.cases[caseId].glsproducts
    let handleForm = checkToAddProduct(productInfo, glsProducts);

    if (handleForm) {
      setBtnDisabled(false)
      // this.setState({ btnDisabled: false })
      alert(`You have already added one ${formData.glsProductType.name} product. Please select another product`)
    } else {
      onFormSubmit(event, apiURL)
    }
  }

  const onFormSubmit = (event, apiURL) => {
    let caseId = electingCases(props.cases, formData.glsAgent.name);
    var requestData = {};
    let glsAgent = {
      name: props.cases[caseId].entityName,
      value: props.cases[caseId].entityId
    }

    props.setGslAgent(glsAgent);

    requestData.caseId = caseId;

    if (formData.glsProductType.value === 'notionalPool') {
      requestData = {
        ...formData,
        notionalPooling: {},
        caseId
      }
    } else if (formData.glsProductType.value === 'cashcon') {
      requestData = {
        ...formData,
        caseId,
        cashConcentration: {}
      }
    } else if (formData.glsProductType.value === 'interest') {
      requestData = {
        ...formData,
        interestEnhancement: {},
        caseId
      }
    }

    if (props.mode === 'edit') {
      apiURL = apiURL + "/" + formData.id;
    }

    var METHOD = props.mode === 'edit' ? 'PUT' : 'POST';
    (async () => {
      const { data } = await eapiClient(apiURL, {
        method: METHOD,
        data: JSON.stringify(requestData)
      });
      var { caseId } = data.responseData;
      props.updateCase(caseId, 'glsproducts', Object.assign({}, formData, { id: data.responseData.id }));
      props.history.goBack();
    })();
  }

  const onFormCancel = () => {
    props.history.goBack();
  }

  const renderFormGroups = () => {
    let formData;
    let mode;
    if (props.currentglsProduct !== undefined) {
      formData = { ...props.currentglsProduct };
    } else if (Object.keys(props.glsAgent).length > 0) {
      formData = {
        glsAgent: props.glsAgent
      }
      mode = 'edit'
    }
    else {
      formData = {};
    }
    const properties = {
      glsProductId: props.match.params.glsProductId,
      caseId: props.match.params.caseId,
      formData,
      editType: 'add-glsProduct-to-case',
      pathname: props.history.location.pathname
    };
    if (formJson !== undefined && formJson.par.aemform_ !== undefined) {
      return (
        <Dynamicform mode={props.mode}
          properties={properties}
          url={FORM_REFS[formJson.par.aemform_.formRef]}
          getFormData={getFormData}
          onFormSubmit={submitFormData}
          onFormCancel={onFormCancel}
          lang={props.lang.currentLang.lang}
          mode={Object.keys(props.glsAgent).length > 0 ? 'edit' : ''}
          disabled={Object.keys(props.glsAgent).length > 0 ? true : ''}
          translatedData={props.lang.translatedData}
          btnDisabled={btnDisabled}
          flag={props.lang.currentLangFlag.flag}
        />
      );
    }
  }


  const pageTitle = formJson ? formJson.par.page_title_mainTitle : '';

  return (
    (pageTitle !== undefined)
      ? (<div>
        <div className="form-container">
          <div className="form-title">
            <h2 className="form-heading">{translations(pageTitle.pageHeading)}</h2>
            <p className="form-required-desc">{translations(pageTitle.descriptionText)}</p>
          </div>
          {renderFormGroups()}
        </div>
      </div>)
      : ''
  );

}

const mapStateToProps = (state, props) => {
  let currentglsProduct;
  if (props.match.params) {
    let { caseId, glsProductId } = props.match.params;
    if (caseId && glsProductId && state.cases[caseId] && state.cases[caseId]['glsproducts'][glsProductId]) {
      currentglsProduct = state.cases[caseId]['glsproducts'][glsProductId]
    }
  }
  return {
    currentglsProduct,
    cases: state.cases,
    mode: currentglsProduct !== undefined ? 'edit' : '',
    lang: state.lang,
    glsAgent: state.glsAgent,
    glsProductDetails: state.productDetails.gls
  }
}

const mapDispatchToProps = dispatch => {
  return {
    hideActionButton: () => {
      dispatch(hideActionButton())
    },
    updateCase: (caseId, productType, productData) => {
      dispatch(updateCase(caseId, productType, productData))
    },
    setGslAgent: (glsAgentData) => {
      dispatch(setGslAgent(glsAgentData))
    },
  }
}

CreateNewGLSproduct.propTypes = {
  cases: PropTypes.object,
  lang: PropTypes.object,
  history: PropTypes.object,
  currentglsProduct: PropTypes.object,
  match: PropTypes.object,
  glsAgent: PropTypes.object,
  updateCase: PropTypes.func,
  setGslAgent: PropTypes.func,
  hideActionButton: PropTypes.func,
  hideCrumbs: PropTypes.func,
};


export default connect(mapStateToProps, mapDispatchToProps)(CreateNewGLSproduct);



// WEBPACK FOOTER //
// ./src/components/createAcase/AddGLSproduct/CreateNewGLSproduct.js